import * as React from 'react';

interface Props {
  backdropClassName: string;
  className: string;
  labelledBy: string;
  onClose: () => void;
  children: React.ReactNode;
}

export class AccessibleModal extends React.Component<Props> {
  private panel = React.createRef<HTMLDivElement>();
  private previousFocus?: HTMLElement;

  componentDidMount() {
    this.previousFocus = document.activeElement as HTMLElement;
    document.addEventListener('keydown', this.onKeyDown);
    const target = this.panel.current && this.panel.current.querySelector<HTMLElement>('[autofocus], input, textarea, select, button, [tabindex]:not([tabindex="-1"])');
    window.setTimeout(() => (target || this.panel.current)?.focus(), 0);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    if (this.previousFocus && document.body.contains(this.previousFocus)) this.previousFocus.focus();
  }

  private onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.props.onClose();
      return;
    }
    if (event.key !== 'Tab' || !this.panel.current) return;
    const focusable = Array.from(this.panel.current.querySelectorAll<HTMLElement>('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) { event.preventDefault(); this.panel.current.focus(); return; }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  render() {
    const {backdropClassName, className, labelledBy, onClose, children} = this.props;
    return <div className={backdropClassName} onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
      <div ref={this.panel} className={className} role="dialog" aria-modal="true" aria-labelledby={labelledBy} tabIndex={-1}>{children}</div>
    </div>;
  }
}
